import { createFileRoute } from '@tanstack/react-router'
import { loaderSeason } from '~/features/compensation/queries'
import { BudgetsPage } from '~/features/finance/BudgetsPage'
import { NoFinanceAccess } from '~/features/finance/parts'
import { budgetsQuery } from '~/features/finance/queries'
import { useCan } from '~/lib/session'

export const Route = createFileRoute('/_app/verein/budgets/')({
  loader: async ({ context }) => {
    const s = await loaderSeason(context.queryClient)
    if (s?.canRead) await context.queryClient.ensureQueryData(budgetsQuery(s.season))
  },
  component: function Budgets() {
    return useCan()('finance.read') ? <BudgetsPage /> : <NoFinanceAccess title="Budgets" />
  },
})
